import React, { Component } from "react";
import "./App.css";
import SideMenu from "./components/SideMenu";
import Stepper from "./components/stepper";
import VideoSelector from "./components/VideoSelector";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import HomeIcon from "@material-ui/icons/Home";

const axios = require("axios");
var hasSent = false;

function whenFinished(reps) {
  if (hasSent) {
    return;
  }
  hasSent = true;
  const email = localStorage.getItem("email");

  const url = `/.netlify/functions/googleSheets?email=${email}&reps=${reps}`;

  axios
    .get(url)
    .then(console.debug)
    .catch(console.error);
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  }
}));

function TopBar() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <a style={{ color: "inherit" }} href="https://livefe.fit">
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
            >
              <HomeIcon />
            </IconButton>
          </a>
          <Typography variant="h6" className={classes.title}>
            Live Life Squat Challenge
          </Typography>
          {/* <Button color="inherit">Login</Button> */}
        </Toolbar>
      </AppBar>
    </div>
  );
}

class App extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();

    this.startFunc = () => {
      this.child.current.sVideo();
    };
  }

  render() {
    return (
      <div className="App">
        <TopBar />
        <Stepper startFunc={this.startFunc} />
        <VideoSelector ref={this.child} whenFinished={whenFinished} />
      </div>
    );
  }
}

export default App;
